import { render, staticRenderFns } from "./BaseSpinner.vue?vue&type=template&id=9bc1c1ae&"
var script = {}
import style0 from "./BaseSpinner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports